import React, { useContext } from "react";
import { LAText, LAView } from "../../components";
import { STRINGS } from "../../constant";
import { IMAGES } from "../../assets";
import { ThemeContext } from "../../context/ThemeProvider";
import { getStudyIconBg } from "../../utils/themeUtils";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTimes, 
  faUsers, 
  faChartPie,
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';

const CommunityPopup = ({ onCancle, communitySettings }) => {
  const { theme, currentTheme } = useContext(ThemeContext);

  // Helper function to get icon background color
  const getIconBg = () => {
    return getStudyIconBg(theme, currentTheme);
  };

  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };

  // Animation variants
  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.2 } },
    exit: { opacity: 0, transition: { duration: 0.15 } }
  };

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 20 },
    visible: { 
      opacity: 1, 
      scale: 1,
      y: 0,
      transition: { 
        duration: 0.3,
        type: "spring",
        stiffness: 300,
        damping: 25
      }
    },
    exit: { 
      opacity: 0, 
      scale: 0.9,
      y: 20,
      transition: { duration: 0.2 }
    }
  };

  // Get icon based on color
  const getStatusIcon = () => {
    if (communitySettings?.color === theme.COLOR_GREEN) {
      return faCheckCircle;
    } else if (communitySettings?.color === theme.COLOR_YELLOW) {
      return faExclamationTriangle;
    } else {
      return faExclamationCircle;
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={overlayVariants}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
      >
        <motion.div
          variants={modalVariants}
          className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 w-full max-w-md relative"
        >
          {/* Close Button */}
          <button
            onClick={onCancle}
            className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <FontAwesomeIcon 
              icon={faTimes} 
              style={{ color: getTextColor() }}
            />
          </button>

          {/* Content */}
          <div className="flex flex-col items-center text-center">
            <div className="flex items-center justify-center mb-4">
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center"
                style={{ backgroundColor: communitySettings?.color + '20' }}
              >
                <FontAwesomeIcon 
                  icon={getStatusIcon()} 
                  className="text-3xl"
                  style={{ color: communitySettings?.color }}
                />
              </div>
            </div>

            <h2 
              className="text-xl font-semibold mb-2"
              style={{ color: getTextColor() }}
            >
              {STRINGS.community_popup_title}
            </h2>
            
            <p 
              className="text-gray-500 dark:text-gray-400 mb-4"
            >
              {STRINGS?.community_popup_desc}
            </p>

            <div 
              className="py-4 px-6 rounded-lg w-full"
              style={{ 
                backgroundColor: communitySettings?.color + '15',
                border: `1px solid ${communitySettings?.color}30`
              }}
            >
              <div className="flex items-center justify-center mb-2">
                <FontAwesomeIcon 
                  icon={faUsers} 
                  className="mr-2"
                  style={{ color: communitySettings?.color }}
                />
                <FontAwesomeIcon 
                  icon={faChartPie} 
                  style={{ color: communitySettings?.color }}
                />
              </div>
              <p 
                className="font-medium"
                style={{ color: communitySettings?.color }}
              >
                {communitySettings?.message}
              </p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default CommunityPopup;